export default __webpack_public_path__ + "static/media/profileGeoLocation.d3cfa757.svg";